import { createSelector } from '@reduxjs/toolkit';

import type { CoreRootState } from '../../CoreStore';

export const selectIsMultiVideoStreaming = createSelector(
  [(state: CoreRootState): boolean => state.videoSlice.isMultiVideoStreaming ?? false],
  (isMultiVideoStreaming) => isMultiVideoStreaming
);
